/* eslint-disable import/order */
import { createApp } from 'vue';
// import BootstrapVue from 'bootstrap-vue';
import BootstrapVueNext from 'bootstrap-vue-next';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

//import Toaster from 'v-toaster';
import VTooltip from 'v-tooltip';
import vClickOutside from 'click-outside-vue3';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import Avatar from "vue3-avatar";
import App from './App.vue';
import router from './router';
import store from './vuex/store';
import VueTelInput from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import '@vuepic/vue-datepicker/dist/main.css';

import '@flaticon/flaticon-uicons/css/regular/rounded.css';
import VOtpInput from "vue3-otp-input";
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import { lucideVueNext } from 'lucide-vue-next';
const vuetify = createVuetify({
    components,
    directives,
});
import * as vennModule from 'highcharts/modules/venn';

// Conditionally initialize the module
if (typeof vennModule === 'function') {
  vennModule(Highcharts);
} else if (vennModule && typeof vennModule.default === 'function') {
  vennModule.default(Highcharts);
} else {
  console.warn('Venn module auto-registration should occur');
}
const app = createApp(App);
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
// import {defineConfig} from 'vite'
// import vue from '@vitejs/plugin-vue'
// import Icons from 'unplugin-icons/vite'

// // https://vitejs.dev/config/
// export default defineConfig({
//   plugins: [
//     vue(),
//     Icons({
//       compiler: 'vue3',
//     }),
//   ],
// })
app.use(Vue3Toastify, {
    autoClose: 3000,
});
//only new thing added for lucid Vue

app.use(store);
app.use(VueTelInput);
app.use(router);
app.use(vuetify);
app.use(Avatar);
app.use(lucideVueNext);
app.mount('#app');
import 'feather-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
app.component('font-awesome-icon', FontAwesomeIcon)
// app.use(require('vue-moment'));

import Vue from 'vue'
import YouTube from 'vue3-youtube'
app.use(YouTube);
//import Toggle from 'vue3-toggle';
// import ToggleButton from 'vue-js-toggle-button';
//import "vue3-toggle";
//app.use(ToggleButton)
// app.use(Toggle);
import Vidle from 'v-idle-3';

app.use(Vidle);

import 'tablesaw/dist/tablesaw.css';
import 'tablesaw/dist/tablesaw.js';

app.use(BootstrapVueNext);
// app.use(BootstrapIconsPlugin);
import VueApexCharts from 'vue3-apexcharts';
import { paramsSerializer } from '@/helpers/paramsSerializer';

import registerBootstrap from './registerBootstrap';
import { errorCodes } from './constants/core';
// import 'vue-expand-panel/dist/vue-expand-panel.css';


// Initialize Venn module BEFORE creating the app


import './assets/theme/fonts/fonts/font-awesome.min.css';

// import 'vue2-datepicker/index.css';
//import 'v-toaster/dist/v-toaster.css';
import 'vue-multiselect/dist/vue-multiselect.css';
import './styles/index.scss';
import './styles/feedback/media.css';
import './styles/charts/charts.css';
 



app.use(HighchartsVue);
import axios from 'axios';

import { setupCalendar } from 'v-calendar';

// Use calendar defaults (optional)
app.use(setupCalendar, {});

import FormWizard from 'vue3-form-wizard';
import 'vue3-form-wizard/dist/style.css';
app.use(FormWizard);

app.use(VTooltip);
app.use(vClickOutside);
app.use(VueApexCharts);
// eslint-disable-next-line vue/multi-word-component-names
app.component('apexchart', VueApexCharts);
app.component('v-otp-input', VOtpInput)

registerBootstrap(app);
import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'; //Optional default CSS
app.use(SimpleTypeahead);
app.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCFmGmXOZZx2cQg3JZobKOjRMCd6j07OfM',
      libraries: 'places', // This is required if you use the Autocomplete plugin
    },
});

app.config.debug = true;
app.config.productionTip = false;
// app.config.globalProperties.Vue.http = axios;

router.beforeEach(async (to, from, next) => {
    // const { authorize } = to.meta;
    if (!window.localStorage.getItem('token')) {
        if (['sign-in', 'sign-up', 'forgot-password', 'reset-password', 'manager-verify-email', 'manager-invite-page', 'verified', 'job-template', 'verify-email', 'verify-user-email', 'verify-changed-email', 'delete-user-account-instruction'].find((x) => x === to.name)) {
            next();
        } else {
            store.dispatch('authLogout');
            // next({ name: 'sign-in' });
        }
    } else if (to.path.startsWith('/old') && !store.getters.account.isSuperUser) {
        next({ path: '/jobs/list', params: { access_message: true } });
    } else {
        await store.dispatch('getAccountData');
        next();
        // if (authorize.length && !authorize.includes(store.getters.account.role)) {
        //  next({ path: '/jobs/list' });
        // } else {
        //  next();
        // }
    }
});

axios.interceptors.request.use((request) => {
    request.headers.set('version', __env.APP_VERSION);
    request.headers.set('Authorization', 'Bearer '.concat(window.localStorage.getItem('token')));

    if (/old/.test(window.location.href)) {
        request.headers.set('x-institutionid', window.localStorage.getItem('currentInstitutionId'));
    }
    next((res) => {
        if (!res.ok) {
            if (res.status === 401 && (res.body.error.code === errorCodes.AUTH_REQUIRED || res.body.error.code === errorCodes.INVALID_TOKEN)) {
                store.dispatch('authLogout');
            }
            if (res.body?.code === 403) {
                store.dispatch('showError', res.body.data);
            }
        }
        return res;
    });
});
// /* eslint-disable no-param-reassign */
// app.http.interceptors.push((request, next) => {
//  if (Object.keys(request.params).length !== 0) {
//      request.url = `${request.url}${paramsSerializer(request.params)}`;
//      request.params = {};
//  }
//  next();
// });

/* eslint-disable no-param-reassign */
axios.interceptors.request.use((request) => {
    if (Object.keys(request.params).length !== 0) {
        request.url = `${request.url}${paramsSerializer(request.params)}`;
        request.params = {};
    }
});

//  axios.interceptor.before = (request, next) => {
//  request.url = __env.API_URL + request.url;
//  next();
// };
//  axios.interceptor.before = (request, next) => {
//  request.url = __env.API_URL + request.url;
//  next();
// };